































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import CnpjBulklog from '../../model/resource/CnpjBulklog'
import Responsavel from '../../model/resource/Responsavel'

const metaInfo = () => ({
    title: $.t('view.manage.cnpjBulk.title'),
})

@Component({
    metaInfo,
})
export default class ManageCnpjBulklogView extends Mixins(MixinFilter, MixinSelect) {

    @Getter('auth/responsavel') user!: Responsavel
    AppConfig = AppConfig
    pushByName = pushByName

    collection = new PageCollection(CnpjBulklog, {}, 10)

    created() {
        this.collection.endpoint = '/user/cnpj-bulklog'
    }
}
